import Route from '@ember/routing/route';

export default class LoggedOutRoute extends Route {}
